import Withdraw from "./Svg/Withdraw";
import { Link } from "react-router-dom";
import EmptyTransaction from "./EmptyTransaction";
import Transactions from "./Transactions";
import DashboardHeader from "./DashboardHeader";
import Moment from "react-moment";
import { useOutletContext, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
// import autoMode from "../assets/autoMode.svg"


function RecentTransactions() {
  const date = new Date();
  const [ paylink, Bal, username, fullname, trans] = useOutletContext();
  const [showTrans, setShowTrans] = useState([])
  const {token} = useParams();

  useEffect(() => {
    const getAllTransactions = async (username, token) => {
      const getOptions = {
        method: 'GET',
        headers: {
          "Content-Type" : "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
         }
      };
      await fetch (`${process.env.REACT_APP_API_URL}/dashboard/transaction-history/${username}
      `, getOptions)
      .then (response => response.json())
      .then (data => {
        const Alltrans = data.transactions;
        setShowTrans(Alltrans)
         })
      .catch(err => console.log(err))
    }

    getAllTransactions(username, token)
  },[username,token])

  return ( 
      <>
      <DashboardHeader title="Transaction History" profilename={fullname}/>
      <div className="recent-trans-container">
      <div className="trans-content-top">
          <div className="content-top-left">
          <h4 className="greet-user">
            Hello, {fullname} 👋
          </h4>
          <Moment className="dashboard-date" format="dddd, MMMM Do, YYYY">{date}</Moment>
          </div>
          <div className="content-top-right">
            <Link className="withdraw-group" to="../withdraw">
              <Withdraw className="withdraw-icon" fill="#60B0F4" />
              Withdraw Funds
            </Link>
          </div>
        </div>
      <h4 className="trans-head">Transactions</h4>
      {showTrans.length  ?  <Transactions showTrans={showTrans} /> : <EmptyTransaction />}
  </div>
      </>
 
  )
}

export default RecentTransactions